export var CollectionCarouselPage;
(function(CollectionCarouselPage) {
    CollectionCarouselPage["COLLECTION"] = "COLLECTION";
    CollectionCarouselPage["BRAND"] = "BRAND";
    CollectionCarouselPage["PDP"] = "PDP";
    CollectionCarouselPage["SEE_ALL"] = "SEE_ALL";
})(CollectionCarouselPage || (CollectionCarouselPage = {}));
export var CollectionImpression;
(function(CollectionImpression) {
    CollectionImpression["COLLECTION_CAROUSEL"] = "COLLECTION_CAROUSEL";
    CollectionImpression["BRAND_CAROUSEL"] = "BRAND_CAROUSEL";
    CollectionImpression["COLLECTION_TILE"] = "COLLECTION_TILE";
})(CollectionImpression || (CollectionImpression = {}));
